module.exports = __webpack_public_path__ + "static/img/bim3330.36fd7c23.png";